up.Blocked = class Blocked extends up.Error {
};
